import { render } from "./PageTitleEmit.vue?vue&type=template&id=00e513e9&scoped=true"
import script from "./PageTitleEmit.vue?vue&type=script&lang=js"
export * from "./PageTitleEmit.vue?vue&type=script&lang=js"

import "./PageTitleEmit.vue?vue&type=style&index=0&id=00e513e9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e513e9"]])

export default __exports__